export function isFileUploadError(uploadResult) {
    return uploadResult.error !== undefined;
}
export async function uploadFiles(file, requestId, pageId) {
    const formData = new FormData();
    file.forEach(file => {
        formData.append('file[]', file);
    });
    // Append requestId, so multiple people can upload the same file, but for each request, the user cannot accidentially upload the same file
    formData.append('requestId', requestId);
    formData.append('pageId', pageId);
    return fetch(`${process.env.BASE_URL}/hatchery/upload`, {
        method: 'POST',
        body: formData,
    })
        .then(res => res.json())
        .then(res => res.files);
}
